import { gql, useQuery } from '@apollo/client';
import { OfferFilesGetDto, QueryGetFilesFromOfferArgs } from '../types/types';

export const GET_FILES_FROM_OFFER = gql`
  query GetFilesFromOffer($id: String!) {
    getFilesFromOffer(id: $id) {
      documents {
        fileId
        fileName
        downloadLink
      }
    }
  }
`;

interface GetFilesFromOfferQuery {
  getFilesFromOffer?: OfferFilesGetDto | null;
}

export function useGetOfferFiles(id?: string) {
  const { data, loading, error, refetch } = useQuery<
    GetFilesFromOfferQuery,
    QueryGetFilesFromOfferArgs
  >(GET_FILES_FROM_OFFER, {
    variables: { id: id! },
    skip: !id,
  });

  return {
    offerFiles: id ? data?.getFilesFromOffer : null,
    loading,
    error,
    refetch,
  };
}
